import { render, staticRenderFns } from "./DateCreated.vue?vue&type=template&id=143ec382&"
import script from "./DateCreated.vue?vue&type=script&lang=js&"
export * from "./DateCreated.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports